import { escapeSpecialRegExpChars } from '@gp/utils/common';
import { REGS } from '@gp/constants/regPatterns';

export const getRegExpInstance = (keyword?: string, flag: 'i' | 'g' | 'ig' = 'ig'): RegExp | string => {
  if (!keyword) return '';
  let result: RegExp | string = '';
  try {
    const escapedKeyword = escapeSpecialRegExpChars(keyword);
    result = new RegExp(escapedKeyword, flag);
  } catch (exception) {
    console.error(exception);
    result = keyword;
  }
  return result;
};

export const validateEmail = (email?: string): boolean => {
  if (!email) return false;
  REGS.EMAIL_REG.lastIndex = 0;
  return REGS.EMAIL_REG.test(email);
};
